<template>
    <div class="FooterSocialsLinks col-span-1 flex flex-row justify-between md:col-span-2 md:flex-col">
        <div class="ml-3.5 md:ml-0">
            <div class="mb-3.5 hidden text-lg font-medium leading-none text-black dark:text-txt-headings sm:block">Sleduj nás</div>
            <div class="mt-1 flex sm:mt-0">
                <a
                    class="mr-3 text-black dark:text-txt-headings hover:text-facebook"
                    href="https://www.facebook.com/growni.sk"
                    rel="noopener"
                    target="_blank"
                >
                    <CIcon name="facebook-outline" title="Facebook GROWNi" />
                </a>

                <a
                    class="mr-3 text-black dark:text-txt-headings hover:text-instagram"
                    href="https://www.instagram.com/growni.sk"
                    rel="noopener"
                    target="_blank"
                >
                    <CIcon name="instagram" title="Instagram GROWNi" />
                </a>

                <a
                    class="mr-3 text-black dark:text-txt-headings hover:text-youtube"
                    href="https://www.youtube.com/channel/UC3F5i2ZNrNY_MwBIz5dvAtw"
                    rel="noopener"
                    target="_blank"
                >
                    <CIcon name="youtube-outline" title="YouTube GROWNi" />
                </a>

                <a
                    class="text-black dark:text-txt-headings hover:text-linkedin"
                    href="https://www.linkedin.com/company/grownisk/"
                    rel="noopener"
                    target="_blank"
                >
                    <CIcon name="linkedin-outline" title="LinkedIn GROWNi" />
                </a>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CIcon from '@/components/ui/CIcon.vue'
</script>
